import type { IdentifiedClient } from '@asko/shared';
import { countryName } from '@asko/shared';
import { formatIsoDate } from '../lib/format';
import { useI18n, type MessageKey } from '../lib/i18n';

interface ClientCardProps {
  client: IdentifiedClient;
  /**
   * Mijoz ilgari identifikatsiyadan o'tgan bo'lsa — qachon o'tgani.
   * Sotuvchi MyID nega so'ralmaganini bilib turishi kerak.
   */
  identifiedAt?: string | null;
}

/** Identifikatsiyadan o'tgan mijoz kartochkasi. Maxfiy maydonlar maskalangan. */
export function ClientCard({ client, identifiedAt = null }: ClientCardProps) {
  const { t, lang } = useI18n();

  const fullName = [client.lastName, client.firstName, client.middleName]
    .filter(Boolean)
    .join(' ');

  const rows: Array<[MessageKey, string | null]> = [
    ['client.birthDate', formatIsoDate(client.birthDate)],
    ['client.pinfl', client.pinflMasked],
    ['client.passport', client.passport],
    ['client.phone', client.phone],
    ['client.card', client.cardMasked],
    // MyID fuqarolikni kod bilan beradi — nomga shu yerda aylantiramiz,
    // chunki u tilga bog'liq va sotuvchi tilni almashtirishi mumkin.
    ['client.citizenship', countryName(client.citizenshipCode, lang)],
    ['client.address', client.address],
  ];

  return (
    <div className="client-card">
      <div className="client-card__head">
        <div>
          <div className="client-card__name">{fullName}</div>
          <div className="client-card__verified">
            {identifiedAt
              ? t('client.reused', { date: formatIsoDate(identifiedAt.slice(0, 10)) ?? '' })
              : t('client.verified')}
          </div>
        </div>
        {client.comparisonValue !== null && (
          <div className="client-card__score" title={t('client.similarity')}>
            {(client.comparisonValue * 100).toFixed(0)}%
          </div>
        )}
      </div>

      <dl className="client-card__grid">
        {rows
          .filter(([, value]) => Boolean(value))
          .map(([key, value]) => (
            <div key={key} className="client-card__row">
              <dt>{t(key)}</dt>
              <dd>{value}</dd>
            </div>
          ))}
      </dl>
    </div>
  );
}
